module.exports = __webpack_public_path__ + "5cb0ce7854202ca6aad5bd843995d402.svg";